import { render, staticRenderFns } from "./OperaModuleWindow.vue?vue&type=template&id=56cfd32e&"
import script from "./OperaModuleWindow.vue?vue&type=script&lang=js&"
export * from "./OperaModuleWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports